import { useState } from "react";

export default function useAlertConfig(time) {
  const [alertConfig, setAlertConfig] = useState(null);

  function showAlert(message, status) {
    setAlertConfig({
      message,
      status,
    });
    setTimeout(() => {
      setAlertConfig(null);
    }, time * 1000);
  }

  function showSuccessAlert(message) {
    showAlert(message, "success");
  }

  function showFailureAlert(message) {
    showAlert(message, "failure");
  }
  return { alertConfig, showSuccessAlert, showFailureAlert };
}
